import { queryOptions } from '@tanstack/react-query';

import { actionLogsApi, type GetActionLogsResponse } from '@/shared/api';
import { actionLogsKeys } from '@/shared/lib/queryKeys';

export { actionLogsKeys };

export const actionLogsQueryOptions = {
  byClient: (clientId: string) =>
    queryOptions<GetActionLogsResponse>({
      queryKey: actionLogsKeys.byClient(clientId),
      queryFn: ({ signal }) => actionLogsApi.listForClient(clientId, { signal }),
      meta: { errorToast: 'Failed to load history. Contact support.' },
    }),
};
